import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { resolveRedirect } from "@/lib/redirects";

export const Route = createFileRoute("/$")({
  head: () => ({
    meta: [
      { title: "Page not found | Ajility" },
      {
        name: "description",
        content:
          "That page does not exist or has moved. Browse Ajility's fractional COO services, published pricing or operating insights.",
      },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  beforeLoad: ({ location }) => {
    const destination = resolveRedirect(location.pathname);
    if (destination) {
      throw redirect({ href: destination, statusCode: 301, reloadDocument: false });
    }
    throw notFound();
  },
  component: NotFoundPage,
  notFoundComponent: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-6 py-32 text-center">
      <h1 className="font-serif text-4xl text-foreground sm:text-5xl">Page not found</h1>
      <p className="mt-5 text-lg text-charcoal">
        That page does not exist or has moved. Browse the services, published pricing or operating
        insights instead.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="inline-flex h-12 items-center rounded-full bg-midnight px-7 text-sm font-semibold text-frost transition hover:bg-midnight-deep"
        >
          Return home
        </Link>
        <Link
          to="/services"
          className="inline-flex h-12 items-center rounded-full border border-border px-7 text-sm font-semibold text-midnight transition hover:bg-mist"
        >
          View services
        </Link>
      </div>
    </div>
  );
}
